import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { ArrowLeftIcon, ArrowRightIcon } from '@eventbrite/marmalade';
import {
    getPaginationData,
    handleGetPage as handleGetPageAction,
    Pagination,
    PaginationData,
} from '@eventbrite/search-utils';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import styles from './PaginationControls.module.scss';

interface PaginationControlsProps {
    pagination: PaginationData;
    handleGetPage: Function;
}

export const PaginationControls: React.FunctionComponent<
    PaginationControlsProps
> = ({ pagination, handleGetPage }) => {
    const { currentPage, totalNumResults } = getPaginationData(pagination);

    const handlePageSelect = useCallback(
        (pageNumber: number) => {
            if (HAS_WINDOW) {
                window.scrollTo(0, 0);
            }

            handleGetPage(pageNumber);
        },
        [handleGetPage],
    );

    return (
        <div className={styles.paginationWrapper}>
            <Pagination
                pageNumber={currentPage}
                totalNumResults={totalNumResults}
                onSelected={handlePageSelect}
                prevIcon={
                    <div className={styles.paginationButton}>
                        <ArrowLeftIcon size="medium" />
                    </div>
                }
                nextIcon={
                    <div className={styles.paginationButton}>
                        <ArrowRightIcon size="medium" />
                    </div>
                }
            />
        </div>
    );
};

const _mapDispatchToProps = {
    handleGetPage: handleGetPageAction,
};

export default connect(null, _mapDispatchToProps)(PaginationControls);
